// import React, { useContext, useEffect, useState } from 'react'
// import AdminContext from '../../StateContext/Application'
// import { apiurl } from '../../../../path'

// import { useLanguage } from '../../../../lang/langcontext/LanguageContext'

// const DemandRequestOutwards = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext)
//     const { GetDemandRequestOutwardsFunction } = context;

//     const [technicalInwards, setTechnicalInwards] = useState([])
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [selectedProposal, setSelectedProposal] = useState(null);
//     const [proposallist, setProposalList] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const billsPerPage = 10;
//     const [searchTerm, setSearchTerm] = useState('');
//     const budgetEstimation = proposallist;

//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);


//     const headerStyle = {
//         padding: "12px 16px",
//         whiteSpace: "nowrap",
//         borderRight: "1px solid #e0e0e0",
//         textTransform: "capitalize",
//     };
//     const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

//     const headerStyle1 = {
//         width: commonWidth,
//         padding: '12px 16px', whiteSpace: 'nowrap',
//         borderRight: '1px solid #e0e0e0',
//         textTransform: 'capitalize'
//     };

//     const cellStyle = {
//         width: commonWidth, // 100% / 7 columns
//         padding: '8px',
//         textAlign: 'center',
//         //   whiteSpace: 'nowrap'
//     };

//     const getTechnicalInwardsList = async () => {
//         let data = await GetDemandRequestOutwardsFunction('', '')
//         const { status, message } = data;
//         // let data1 = await TechnicalOutwards("Bill")
//         console.log("data1------------", data);
//         console.log("data------------", data);
//         if (status) {
//             const sortedData = message.sort((a, b) =>
//                 new Date(a.created_At) - new Date(b.created_At)
//             );
//             setTechnicalInwards(sortedData);
//             setProposalList(sortedData);
//         }
//         else {
//             alert(message);
//         }

//     }

//     useEffect(() => {
//         getTechnicalInwardsList()
//     }, []);

//     let inwardList = []
//     if (technicalInwards && technicalInwards?.length > 0) {
//         inwardList = technicalInwards
//     }
//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = technicalInwards?.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, technicalInwards]);



//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = budgetEstimation.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, budgetEstimation]);



//     // return (

//     //     <>

//     //         <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
//     //             <div className="col-11 m-auto">
//     //                 <div className='col-12 '>
//     //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//     //                         <h5 className='my-auto fw-bold'>
//     //                             <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//     //                             <span className='my-auto'>Demand Request Outward</span>
//     //                         </h5>
//     //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//     //                             <img
//     //                                 src="/Search32.png"
//     //                                 alt="Search Icon"
//     //                                 style={{
//     //                                     position: "absolute",
//     //                                     top: "50%",
//     //                                     left: "10px",
//     //                                     transform: "translateY(-50%)",
//     //                                     width: "16px",
//     //                                     height: "16px",
//     //                                     opacity: 0.6
//     //                                 }}
//     //                             />
//     //                             <input
//     //                                 type="text"
//     //                                 placeholder="Search"
//     //                                 onChange={(e) => setSearchTerm(e.target.value)}
//     //                                 value={searchTerm}
//     //                                 style={{
//     //                                     width: "100%",
//     //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
//     //                                     border: "1px solid #ccc",
//     //                                     borderRadius: "8px",
//     //                                     backgroundColor: "#f1f6fc",
//     //                                     fontSize: "14px",
//     //                                     color: "#333",
//     //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//     //                                     outline: "none"
//     //                                 }}
//     //                             />
//     //                         </div>
//     //                     </div>


//     //                     <div className='col-12 pb-5'>
//     //                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//     //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//     //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//     //                                     <thead>
//     //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Sr.No.</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Financial Year</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Head Code</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Work Name</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>MHUID Number</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Physical value (%)</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>District</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Expenditure Amount</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Approved Demand Request Amount</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Available Work Order Amount</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Available Amount for Demand Request</th>
//     //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Date</th>
//     //                                             <th style={headerStyle} colSpan={2}>Approved by</th>
//     //                                         </tr>
//     //                                         <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//     //                                             <th style={headerStyle1}>District Department Maker</th>
//     //                                             <th style={headerStyle1}>Department HOD(EE)</th>
//     //                                         </tr>
//     //                                     </thead>

//     //                                     <tbody >
//     //                                         {currentBills?.length === 0 ? (
//     //                                             <tr>
//     //                                                 <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//     //                                                     No data available
//     //                                                 </td>
//     //                                             </tr>
//     //                                         ) : (
//     //                                             currentBills?.map((proposal, index) => {
//     //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//     //                                                 return (
//     //                                                     <tr style={{ backgroundColor: bgColor }} key={index}>
//     //                                                         <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString()}</td>
//     //                                                         <td style={{ padding: '8px 8px' }}>
//     //                                                             {proposal.Approvance1 === 'true' ? (
//     //                                                                 <div className='m-auto'
//     //                                                                     style={{
//     //                                                                         width: '20px',
//     //                                                                         height: '20px',
//     //                                                                         borderRadius: '6px',
//     //                                                                         backgroundColor: '#16C60C',
//     //                                                                         border: 'none',
//     //                                                                         display: 'flex',
//     //                                                                         justifyContent: 'center',
//     //                                                                         alignItems: 'center',
//     //                                                                         fontSize: '13px',
//     //                                                                         color: 'white',
//     //                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     //                                                                     }}
//     //                                                                 >
//     //                                                                     ✓
//     //                                                                 </div>
//     //                                                             ) : proposal.Approvance1 === 'false' ? (
//     //                                                                 <div
//     //                                                                     className='m-auto'
//     //                                                                     style={{
//     //                                                                         width: '20px',
//     //                                                                         height: '20px',
//     //                                                                         borderRadius: '6px',
//     //                                                                         backgroundColor: '#dc2626',
//     //                                                                         border: 'none',
//     //                                                                         display: 'flex',
//     //                                                                         justifyContent: 'center',
//     //                                                                         alignItems: 'center',
//     //                                                                         fontSize: '13px',
//     //                                                                         color: 'white',
//     //                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     //                                                                     }}
//     //                                                                 >
//     //                                                                     ✕
//     //                                                                 </div>
//     //                                                             ) : '-'}
//     //                                                         </td>
//     //                                                         <td style={{ padding: '8px 8px' }}>
//     //                                                             {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//     //                                                                 style={{
//     //                                                                     width: '20px',
//     //                                                                     height: '20px',
//     //                                                                     borderRadius: '6px',
//     //                                                                     backgroundColor: '#16C60C',
//     //                                                                     border: 'none',
//     //                                                                     display: 'flex',
//     //                                                                     justifyContent: 'center',
//     //                                                                     alignItems: 'center',
//     //                                                                     fontSize: '13px',
//     //                                                                     color: 'white',
//     //                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     //                                                                 }}
//     //                                                             >
//     //                                                                 ✓
//     //                                                             </div>) : proposal.Approvance2 === 'false' ? (<div
//     //                                                                 className='m-auto'
//     //                                                                 style={{
//     //                                                                     width: '20px',
//     //                                                                     height: '20px',
//     //                                                                     borderRadius: '6px',
//     //                                                                     backgroundColor: '#dc2626',
//     //                                                                     border: 'none',
//     //                                                                     display: 'flex',
//     //                                                                     justifyContent: 'center',
//     //                                                                     alignItems: 'center',
//     //                                                                     fontSize: '13px',
//     //                                                                     color: 'white',
//     //                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     //                                                                 }}
//     //                                                             >
//     //                                                                 ✕
//     //                                                             </div>) : '-'}
//     //                                                         </td>
//     //                                                     </tr>

//     //                                                 );
//     //                                             })
//     //                                         )}
//     //                                     </tbody>
//     //                                 </table>
//     //                             </div>
//     //                             <div className='col-12 mt-4 mb-2' >
//     //                                 <div className="row">
//     //                                     <div className='col-6'>
//     //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
//     //                                             {proposallist.length > 0
//     //                                                 ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, proposallist.length)} of ${proposallist.length} entries`
//     //                                                 : "Showing 0 to 0 of 0 entries"}

//     //                                         </p>
//     //                                     </div>
//     //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//     //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//     //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//     //                                         <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//     //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//     //                                         <button
//     //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//     //                                             {currentPage}
//     //                                         </button>
//     //                                         <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//     //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//     //                                         <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//     //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//     //                                     </div>
//     //                                 </div>

//     //                             </div>
//     //                         </div>

//     //                     </div>



//     //                 </div>



//     //             </div>

//     //             {
//     //                 selectedProposal && (
//     //                     <div
//     //                         onClick={() => setSelectedProposal(null)}
//     //                         style={{
//     //                             position: 'fixed',
//     //                             top: 0, left: 0,
//     //                             width: '100vw',
//     //                             height: '100vh',
//     //                             backgroundColor: 'rgba(0, 0, 0, 0.84)',
//     //                             display: 'flex',
//     //                             justifyContent: 'center',
//     //                             alignItems: 'center',
//     //                             zIndex: 9999
//     //                         }}
//     //                     >
//     //                         <div
//     //                             onClick={(e) => e.stopPropagation()}
//     //                             style={{
//     //                                 backgroundColor: 'white',
//     //                                 padding: '40px 40px',
//     //                                 borderRadius: '20px',
//     //                                 width: '50%',
//     //                                 maxHeight: '90vh',
//     //                                 overflow: "hidden",
//     //                                 boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//     //                                 position: 'relative'
//     //                             }}
//     //                         >

//     //                             <div className="col-12">

//     //                                 <div className="col-12  mb-3">
//     //                                     <div className="row">
//     //                                         <div className="col-6">
//     //                                             <h5 className='fw-bold'>Bill Details</h5>
//     //                                         </div>

//     //                                         <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//     //                                             <button
//     //                                                 onClick={() => setSelectedProposal(null)}
//     //                                                 style={{
//     //                                                     width: '32px',
//     //                                                     height: '32px',
//     //                                                     borderRadius: '50%',
//     //                                                     backgroundColor: 'red',
//     //                                                     border: 'none',
//     //                                                     display: 'flex',
//     //                                                     justifyContent: 'center',
//     //                                                     alignItems: "center",
//     //                                                     cursor: 'pointer',
//     //                                                     fontSize: '24px',
//     //                                                     fontWeight: 'bold',
//     //                                                     color: 'white',
//     //                                                     lineHeight: 1
//     //                                                 }}
//     //                                             >
//     //                                                 ×
//     //                                             </button>
//     //                                         </div>
//     //                                     </div>
//     //                                 </div>

//     //                                 <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//     //                                     <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//     //                                         <tbody>
//     //                                             {Object.entries(selectedProposal).map(([key, value], index) => (
//     //                                                 <>
//     //                                                     <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//     //                                                         <td style={{
//     //                                                             fontWeight: 'bold',
//     //                                                             padding: '8px',
//     //                                                             width: '40%',
//     //                                                             backgroundColor: '#2B75D5',
//     //                                                             color: 'white',
//     //                                                             border: '1px solid #cce0f9'
//     //                                                         }}>
//     //                                                             {key}
//     //                                                         </td>
//     //                                                         <td style={{
//     //                                                             padding: '8px',
//     //                                                             color: "black",
//     //                                                             backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

//     //                                                         }}>
//     //                                                             {/* Handle Upload Bill Copy link */}
//     //                                                             {key === 'Upload Bill Copy' && value ? (
//     //                                                                 <a href={`${apiurl}/BillCopyDocsImages/${value}`} target="_blank" rel="noreferrer">
//     //                                                                     {value}
//     //                                                                 </a>
//     //                                                             ) : value === null || value === '' ? (
//     //                                                                 '-'
//     //                                                             ) : (
//     //                                                                 value.toString()
//     //                                                             )}
//     //                                                         </td>

//     //                                                     </tr>

//     //                                                 </>
//     //                                             ))}
//     //                                         </tbody>
//     //                                     </table>
//     //                                 </div>

//     //                             </div>

//     //                         </div>
//     //                     </div>
//     //                 )}
//     //         </div>



//     //     </>

//     // )
//     return (

//         <>

//             <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                     <div className='col-12 '>
//                         <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                             <h5 className='my-auto fw-bold'>
//                                 <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                                 <span className='my-auto'>{t("Demand Request Outward")}</span>
//                             </h5>
//                             <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                                 <img
//                                     src="/Search32.png"
//                                     alt="Search Icon"
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         left: "10px",
//                                         transform: "translateY(-50%)",
//                                         width: "16px",
//                                         height: "16px",
//                                         opacity: 0.6
//                                     }}
//                                 />
//                                 <input
//                                     type="text"
//                                     placeholder={t("Search")}
//                                     onChange={(e) => setSearchTerm(e.target.value)}
//                                     value={searchTerm}
//                                     style={{
//                                         width: "100%",
//                                         padding: "8px 12px 8px 32px", // left padding makes space for icon
//                                         border: "1px solid #ccc",
//                                         borderRadius: "8px",
//                                         backgroundColor: "#f1f6fc",
//                                         fontSize: "14px",
//                                         color: "#333",
//                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                         outline: "none"
//                                     }}
//                                 />
//                             </div>
//                         </div>


//                         <div className='col-12 pb-5'>
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                                 <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                                     <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                         <thead>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Sr.No.")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Financial Year")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Head Code")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("MHUID Number")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Physical value (%)")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("District")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Expenditure Amount")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Approved Demand Request Amount")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Available Work Order Amount")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Available Amount for Demand Request")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Date")}</th>
//                                                 <th style={headerStyle} rowSpan={2}>{t("Rejected?")}</th>
//                                                 <th style={headerStyle} rowSpan={2}>{t("Remark")}</th>
//                                                 <th style={headerStyle} rowSpan={2}>{t("Rejected By")}</th>
//                                                  <th style={headerStyle} colSpan={2}>{t("Approved By")}</th>
//                                             </tr>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                                 <th style={headerStyle1}>{t("District Department Maker")}</th>
//                                                 <th style={headerStyle1}>{t("Department HOD(EE)")}</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody >
//                                             {currentBills?.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="13" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                         {t("No data available")}
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 currentBills?.map((proposal, index) => {
//                                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                         <tr style={{ backgroundColor: bgColor }} key={index}>
//                                                             <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString()}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.Status==='NA'?'No':'Yes'}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.RemarkOfRejection}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{proposal.RejectedBy===null?'None':proposal.RejectedBy}</td>
//                                                             <td style={{ padding: '8px 8px' }}>
//                                                                 {proposal.Approvance1 === 'true' ? (
//                                                                     <div className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#16C60C',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✓
//                                                                     </div>
//                                                                 ) : proposal.Approvance1 === 'false' ? (
//                                                                     <div
//                                                                         className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#dc2626',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✕
//                                                                     </div>
//                                                                 ) : '-'}
//                                                             </td>
//                                                             <td style={{ padding: '8px 8px' }}>
//                                                                 {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#16C60C',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✓
//                                                                 </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                     className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#dc2626',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✕
//                                                                 </div>) : '-'}
//                                                             </td>
//                                                         </tr>

//                                                     );
//                                                 })
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                                 <div className='col-12 mt-4 mb-2' >
//                                     <div className="row">
//                                         <div className='col-6'>
//                                             <p className="text-gray-600" style={{ fontSize: "14px" }}>
//                                                 {proposallist.length > 0
//                                                     ? t(`Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, proposallist.length)} of ${proposallist.length} entries`)
//                                                     : t("Showing 0 to 0 of 0 entries")
//                                                 }
//                                             </p>
//                                         </div>
//                                         <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                             <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//                                             <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//                                             <button
//                                                 style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                                 {currentPage}
//                                             </button>
//                                             <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//                                             <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>

//                         </div>



//                     </div>



//                 </div>

//                 {
//                     selectedProposal && (
//                         <div
//                             onClick={() => setSelectedProposal(null)}
//                             style={{
//                                 position: 'fixed',
//                                 top: 0, left: 0,
//                                 width: '100vw',
//                                 height: '100vh',
//                                 backgroundColor: 'rgba(0, 0, 0, 0.84)',
//                                 display: 'flex',
//                                 justifyContent: 'center',
//                                 alignItems: 'center',
//                                 zIndex: 9999
//                             }}
//                         >
//                             <div
//                                 onClick={(e) => e.stopPropagation()}
//                                 style={{
//                                     backgroundColor: 'white',
//                                     padding: '40px 40px',
//                                     borderRadius: '20px',
//                                     width: '50%',
//                                     maxHeight: '90vh',
//                                     overflow: "hidden",
//                                     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                     position: 'relative'
//                                 }}
//                             >

//                                 <div className="col-12">

//                                     <div className="col-12  mb-3">
//                                         <div className="row">
//                                             <div className="col-6">
//                                                 <h5 className='fw-bold'>{t("Bill Details")}</h5>
//                                             </div>

//                                             <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                                 <button
//                                                     onClick={() => setSelectedProposal(null)}
//                                                     style={{
//                                                         width: '32px',
//                                                         height: '32px',
//                                                         borderRadius: '50%',
//                                                         backgroundColor: 'red',
//                                                         border: 'none',
//                                                         display: 'flex',
//                                                         justifyContent: 'center',
//                                                         alignItems: "center",
//                                                         cursor: 'pointer',
//                                                         fontSize: '24px',
//                                                         fontWeight: 'bold',
//                                                         color: 'white',
//                                                         lineHeight: 1
//                                                     }}
//                                                 >
//                                                     ×
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                                         <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                                             <tbody>
//                                                 {Object.entries(selectedProposal).map(([key, value], index) => (
//                                                     <>
//                                                         <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//                                                             <td style={{
//                                                                 fontWeight: 'bold',
//                                                                 padding: '8px',
//                                                                 width: '40%',
//                                                                 backgroundColor: '#2B75D5',
//                                                                 color: 'white',
//                                                                 border: '1px solid #cce0f9'
//                                                             }}>
//                                                                 {key}
//                                                             </td>
//                                                             <td style={{
//                                                                 padding: '8px',
//                                                                 color: "black",
//                                                                 backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

//                                                             }}>
//                                                                 {/* Handle Upload Bill Copy link */}
//                                                                 {key === 'Upload Bill Copy' && value ? (
//                                                                     <a href={`${apiurl}/BillCopyDocsImages/${value}`} target="_blank" rel="noreferrer">
//                                                                         {value}
//                                                                     </a>
//                                                                 ) : value === null || value === '' ? (
//                                                                     '-'
//                                                                 ) : (
//                                                                     value.toString()
//                                                                 )}
//                                                             </td>

//                                                         </tr>

//                                                     </>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                 </div>

//                             </div>
//                         </div>
//                     )}
//             </div>



//         </>

//     )
// }

// export default DemandRequestOutwards;



import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'

import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
const DemandRequestOutwards = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetDemandRequestOutwardsFunction, GetBudgetHeadInfo ,Usermenu } = context;

    const [technicalInwards, setTechnicalInwards] = useState([])
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [selectedProposal, setSelectedProposal] = useState(null);
    const [proposallist, setProposalList] = useState([]);
    const [statusofData, setstatusofData] = useState("");
    const [UserRole, setUserRole] = useState("");
    const [AllDistrict, setAllDistrict] = useState([]);
    const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
        const [SelectedDistrict, setSelectedDistrict] = useState([]);
    const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
const [openDistrict, setOpenDistrict] = useState(false);
const[RoleID,setroleID]=useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
            const [typeofData, settypeofData] = useState("District");
    const budgetEstimation = proposallist;
const [loading, setloading] = useState(false)
    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
     const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
.sort((a, b) => new Date(b.created_At) - new Date(a.created_At))
        : [];
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
    // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [exportingPDF, setExportingPDF] = useState(false);
    const displayedGRS1 = exportingPDF ? filteredBills : currentBills;
       useEffect(() => {
        getTechnicalInwardsList()
    }, []);

    const allDistricts = [
  ...new Set(AllDistrict?.map(d => d.District_Marathi))
];
const isAllSelected =
  SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
  setSelectedDistrict(isAllSelected ? [] : allDistricts);
};
   
    const handleDistrictToggle = (district) => {
  setSelectedDistrict(prev =>
    prev.includes(district)
      ? prev.filter(d => d !== district)
      : [...prev, district]
  );
};

useEffect(() => {
    let filtered = [...technicalInwards];
 if (
      typeofData === "District" &&
      RoleID === 29
    ) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054",filtered)
    } else if (
      typeofData === "State" &&
      RoleID === 29
    ) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 District filter (MULTI-SELECT)
    if (SelectedDistrict?.length > 0) {
        filtered = filtered.filter(item =>
            SelectedDistrict.includes(item.District)
        );
    }

    // 🔹 Status filter
    if (statusofData) {
        if (statusofData === "Pending") {
            filtered = filtered.filter(
                item =>
                    item.Status === "NA" &&
                    (
                        item.Approvance1 === "false" ||
                        item.Approvance2 === "false"
                    )
            );
        }
        else if (statusofData === "Rejected") {
            filtered = filtered.filter(
                item =>
                    (item.Status === "Pending" || item.Status === "Rejected") &&
                    (
                        item.Approvance1 === "false" ||
                        item.Approvance2 === "false"
                    )
            );
        }
          else if (statusofData === "Approved") {   // ✅ Added block
    filtered = filtered.filter(
      item =>
      
        item.Approvance1 === "true" &&
        item.Approvance2 === "true"
    );
  } 
        else {
            filtered = filtered.filter(
                item => item.Status === statusofData
            );
        }
    }

    // 🔹 Search filter
    if (searchTerm.trim()) {
        const lower = searchTerm.toLowerCase();
        filtered = filtered.filter(item =>
            Object.values(item).some(val =>
                String(val ?? "").toLowerCase().includes(lower)
            )
        );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);

}, [
    technicalInwards,
    SelectedDistrict,
    SelectedTalukasofDistrict,
    statusofData,
    searchTerm ,
    typeofData
]);

const getmenu = async () => {
  try {
    const data = await Usermenu();
    if (!data || typeof data !== "object") {
      console.error("Invalid data:", data);
      return;
    }
    const roleID = data?.Data?.RoleID;
      setroleID(roleID)
  console.log("sffdsf",data?.Data)
  } catch (error) {
    console.error("Error in AdminNavbar getmenu:", error);
  }
}; 
    const FetchGramPanachayatInfo = async () => {
        try {
            let res = await GetBudgetHeadInfo('null', "AllDistrict");
            // console.log("Data i get:: ", res);
            setAllDistrict(res);
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        FetchGramPanachayatInfo();
          getmenu();
    }, []);


    useEffect(() => {
        if (SelectedDistrict) {
            let res = AllDistrict.filter((item) => item.District_Marathi === SelectedDistrict);
            setTalukasofDistrict(res);
        }
        else {
            setSelectedDistrict("");
            setSelectedTalukasofDistrict("");
            setTalukasofDistrict([]);
        }
    }, [SelectedDistrict]);


    const getAvailableApprovedDemandRequest = (physicalValue, workOrderAmount, ApprovedDemandRequest) => {
        const pv = Number(physicalValue);
        const woa = Number(workOrderAmount);
        const adra = Number(ApprovedDemandRequest)

        if (pv === 30) return woa - adra;
        if (pv === 50) return woa - (0.50 * woa);
        if (pv === 100) return 0;

        return 0;
    };

    const headerStyle = {
        padding: "12px 16px",
        whiteSpace: "nowrap",
        borderRight: "1px solid #e0e0e0",
        textTransform: "capitalize",
    };
    const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

    const headerStyle1 = {
        width: commonWidth,
        padding: '12px 16px', whiteSpace: 'nowrap',
        borderRight: '1px solid #e0e0e0',
        textTransform: 'capitalize'
    };

    const cellStyle = {
        width: commonWidth, // 100% / 7 columns
        padding: '8px',
        textAlign: 'center',
        //   whiteSpace: 'nowrap'
    };

    const getTechnicalInwardsList = async () => {
        let data = await GetDemandRequestOutwardsFunction('', '')
        const { status, message, Tabletype } = data;
        // let data1 = await TechnicalOutwards("Bill")
        console.log("data1------------", data);
        console.log("data------------", data);
        if (status) {
            const sortedData = message.sort((a, b) =>
                new Date(a.created_At) - new Date(b.created_At)
            );
            setTechnicalInwards(sortedData);
            setProposalList(sortedData);
            setUserRole(Tabletype);
        }
        else {
            alert(message);
        }
    }

 
       const totalExpendeture = filteredBills?.reduce((sum, item) => {
  const amount = Number(item?.ExpenditureAmount);
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);
   const totalapproved = filteredBills?.reduce((sum, item) => {
  const amount = Number(item?.ApprovedDemandRequest);
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);
  const totalworkorder = filteredBills?.reduce((sum, item) => {
  const amount = Number(item?.AvailableWorkOrderAmount);
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);
 const totalavailable = filteredBills?.reduce((sum, item) => {
//   const amount = Number(item?.ReleaseAmountTillDate);
const amount=getAvailableApprovedDemandRequest(     item.physicalValue,
                                                                item.AvailableWorkOrderAmount,
                                                                item.ApprovedDemandRequest,)
  return sum + (isNaN(amount) ? 0 : amount);
}, 0);

const exportTableByClassToExcel = async(
  bills,
  filename = "Demand_Request_Outward.xlsx"
) => {
  if (!Array.isArray(bills) || bills.length === 0) {
    alert("No data available");
    return;
  }
   setloading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
try {
  let totalExpenditure = 0;
  let totalApproved = 0;
  let totalWorkOrder = 0;
  let totalAvailable = 0;

  const excelData = bills.map((proposal, index) => {
    const expenditure = Number(proposal.ExpenditureAmount || 0);
    const approved = Number(proposal.ApprovedDemandRequest || 0);
    const workOrder = Number(proposal.AvailableWorkOrderAmount || 0);

    const available = Number(
      getAvailableApprovedDemandRequest(
        proposal.physicalValue,
        proposal.AvailableWorkOrderAmount,
        proposal.ApprovedDemandRequest
      ) || 0
    );

    totalExpenditure += isNaN(expenditure) ? 0 : expenditure;
    totalApproved += isNaN(approved) ? 0 : approved;
    totalWorkOrder += isNaN(workOrder) ? 0 : workOrder;
    totalAvailable += isNaN(available) ? 0 : available;

    return {
      "Sr.No.": index + 1,
      "Financial Year": proposal.Year || "",
      "Head Code": proposal.HeadCode || "",
      "Work Name": proposal.ProposalWorkName || "",
      "MHUID Number": proposal.MHUID || "",
      "Physical value (%)": proposal.physicalValue || "",
      "District": proposal.District || "",

      "Expenditure Amount": expenditure,
      "Approved Demand Request Amount": approved,
      "Work Order Amount": workOrder,
      "Available Amount for Demand Request": available,

      "Date": proposal.created_At
        ? new Date(proposal.created_At).toLocaleString()
        : "",

      "Rejected?": proposal.Status === "NA" ? "No" : "Yes",
      "Remark": proposal.RemarkOfRejection || "--",
      "Rejected By": proposal.RejectedBy || "None",

      "District Department Maker":
        proposal.Approvance1 === "true"
          ? "✓"
          : proposal.Approvance1 === "false"
          ? "✕"
          : "-",

      "Department HOD(EE)":
        proposal.Approvance2 === "true"
          ? "✓"
          : proposal.Approvance2 === "false"
          ? "✕"
          : "-"
    };
  });

  /* -------- TOTAL ROW -------- */
  excelData.push({
    "Sr.No.": "",
    "Financial Year": "",
    "Head Code": "",
    "Work Name": "TOTAL",
    "MHUID Number": "",
    "Physical value (%)": "",
    "District": "",

    "Expenditure Amount": totalExpenditure,
    "Approved Demand Request Amount": totalApproved,
    "Work Order Amount": totalWorkOrder,
    "Available Amount for Demand Request": totalAvailable,

    "Date": "",
    "Rejected?": "",
    "Remark": "",
    "Rejected By": "",
    "District Department Maker": "",
    "Department HOD(EE)": ""
  });

  /* -------- XLSX CONFIG -------- */

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));
  worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

  // Autofilter (exclude TOTAL row)
  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: {
        r: excelData.length - 2,
        c: Object.keys(excelData[0]).length - 1
      }
    })
  };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Demand Request Outward"
  );
  XLSX.writeFile(workbook, filename);
    } catch (error) {
    console.error("Excel Export Error:", error);
  } finally {
    setloading(false); // ✅ ALWAYS stop loader
  }
};

const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  const CHUNK_SIZE = 500; // 🔥 Adjust if needed (300–500 recommended)

  const originalTable = document.querySelector(`.${tableClass}`);
  if (!originalTable) {
    setExportingPDF(false);
    return;
  }

  setloading(true);
  setExportingPDF(true);

  // Allow loader to render first
  await new Promise((resolve) => setTimeout(resolve, 600));

  try {
    const originalRows = originalTable.querySelectorAll("tbody tr");
    const totalRows = originalRows.length;

    for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
      const end = Math.min(start + CHUNK_SIZE, totalRows);

      // 🔥 Clone table
      const table = originalTable.cloneNode(true);
      const rows = table.querySelectorAll("tbody tr");

      // Remove rows outside current chunk
      rows.forEach((row, index) => {
        if (index < start || index >= end) {
          row.remove();
        }
      });

      document.body.appendChild(table);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const topMargin = 25;
      const sideMargin = 10;
      const bottomMargin = 15;

      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.text(
        `${title} (${start + 1} - ${end})`,
        pageWidth / 2,
        15,
        { align: "center" }
      );

      const canvas = await html2canvas(table, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#2C78DB",
      });

      const imgWidth = pageWidth - sideMargin * 2;
      const pxToMm = imgWidth / canvas.width;

      const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
      const usablePageHeightPx = usablePageHeightMm / pxToMm;

      let renderedHeight = 0;
      let pageNumber = 0;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(
          usablePageHeightPx,
          canvas.height - renderedHeight
        );

        const pageCanvas = document.createElement("canvas");
        const context = pageCanvas.getContext("2d");

        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;

        context.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

        if (pageNumber > 0) pdf.addPage();

        pdf.addImage(
          imgData,
          "JPEG",
          sideMargin,
          topMargin,
          imgWidth,
          sliceHeight * pxToMm
        );

        renderedHeight += sliceHeight;
        pageNumber++;
      }

      pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

      document.body.removeChild(table);

      // Small delay prevents UI freezing
      await new Promise((resolve) => setTimeout(resolve, 300));
    }

  } catch (error) {
    console.error("PDF Export Error:", error);
  } finally {
    setExportingPDF(false);
    setloading(false);
  }
};



    // return (

    //     <>

    //         <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">
    //                 <div className='col-12 '>
    //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                         <h5 className='my-auto fw-bold'>
    //                             <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                             <span className='my-auto'>Demand Request Outward</span>
    //                         </h5>
    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>
    //                     </div>


    //                     <div className='col-12 pb-5'>
    //                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
    //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Sr.No.</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Financial Year</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Head Code</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Work Name</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>MHUID Number</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Physical value (%)</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>District</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Expenditure Amount</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Approved Demand Request Amount</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Available Work Order Amount</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Available Amount for Demand Request</th>
    //                                             <th style={headerStyle} rowSpan={2} colSpan={1}>Date</th>
    //                                             <th style={headerStyle} colSpan={2}>Approved by</th>
    //                                         </tr>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
    //                                             <th style={headerStyle1}>District Department Maker</th>
    //                                             <th style={headerStyle1}>Department HOD(EE)</th>
    //                                         </tr>
    //                                     </thead>

    //                                     <tbody >
    //                                         {currentBills?.length === 0 ? (
    //                                             <tr>
    //                                                 <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                     No data available
    //                                                 </td>
    //                                             </tr>
    //                                         ) : (
    //                                             currentBills?.map((proposal, index) => {
    //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                 return (
    //                                                     <tr style={{ backgroundColor: bgColor }} key={index}>
    //                                                         <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString()}</td>
    //                                                         <td style={{ padding: '8px 8px' }}>
    //                                                             {proposal.Approvance1 === 'true' ? (
    //                                                                 <div className='m-auto'
    //                                                                     style={{
    //                                                                         width: '20px',
    //                                                                         height: '20px',
    //                                                                         borderRadius: '6px',
    //                                                                         backgroundColor: '#16C60C',
    //                                                                         border: 'none',
    //                                                                         display: 'flex',
    //                                                                         justifyContent: 'center',
    //                                                                         alignItems: 'center',
    //                                                                         fontSize: '13px',
    //                                                                         color: 'white',
    //                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    //                                                                     }}
    //                                                                 >
    //                                                                     ✓
    //                                                                 </div>
    //                                                             ) : proposal.Approvance1 === 'false' ? (
    //                                                                 <div
    //                                                                     className='m-auto'
    //                                                                     style={{
    //                                                                         width: '20px',
    //                                                                         height: '20px',
    //                                                                         borderRadius: '6px',
    //                                                                         backgroundColor: '#dc2626',
    //                                                                         border: 'none',
    //                                                                         display: 'flex',
    //                                                                         justifyContent: 'center',
    //                                                                         alignItems: 'center',
    //                                                                         fontSize: '13px',
    //                                                                         color: 'white',
    //                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    //                                                                     }}
    //                                                                 >
    //                                                                     ✕
    //                                                                 </div>
    //                                                             ) : '-'}
    //                                                         </td>
    //                                                         <td style={{ padding: '8px 8px' }}>
    //                                                             {proposal.Approvance2 === 'true' ? (<div className='m-auto'
    //                                                                 style={{
    //                                                                     width: '20px',
    //                                                                     height: '20px',
    //                                                                     borderRadius: '6px',
    //                                                                     backgroundColor: '#16C60C',
    //                                                                     border: 'none',
    //                                                                     display: 'flex',
    //                                                                     justifyContent: 'center',
    //                                                                     alignItems: 'center',
    //                                                                     fontSize: '13px',
    //                                                                     color: 'white',
    //                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    //                                                                 }}
    //                                                             >
    //                                                                 ✓
    //                                                             </div>) : proposal.Approvance2 === 'false' ? (<div
    //                                                                 className='m-auto'
    //                                                                 style={{
    //                                                                     width: '20px',
    //                                                                     height: '20px',
    //                                                                     borderRadius: '6px',
    //                                                                     backgroundColor: '#dc2626',
    //                                                                     border: 'none',
    //                                                                     display: 'flex',
    //                                                                     justifyContent: 'center',
    //                                                                     alignItems: 'center',
    //                                                                     fontSize: '13px',
    //                                                                     color: 'white',
    //                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    //                                                                 }}
    //                                                             >
    //                                                                 ✕
    //                                                             </div>) : '-'}
    //                                                         </td>
    //                                                     </tr>

    //                                                 );
    //                                             })
    //                                         )}
    //                                     </tbody>
    //                                 </table>
    //                             </div>
    //                             <div className='col-12 mt-4 mb-2' >
    //                                 <div className="row">
    //                                     <div className='col-6'>
    //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
    //                                             {proposallist.length > 0
    //                                                 ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, proposallist.length)} of ${proposallist.length} entries`
    //                                                 : "Showing 0 to 0 of 0 entries"}

    //                                         </p>
    //                                     </div>
    //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
    //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
    //                                         <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
    //                                         <button
    //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
    //                                             {currentPage}
    //                                         </button>
    //                                         <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
    //                                         <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
    //                                     </div>
    //                                 </div>

    //                             </div>
    //                         </div>

    //                     </div>



    //                 </div>



    //             </div>

    //             {
    //                 selectedProposal && (
    //                     <div
    //                         onClick={() => setSelectedProposal(null)}
    //                         style={{
    //                             position: 'fixed',
    //                             top: 0, left: 0,
    //                             width: '100vw',
    //                             height: '100vh',
    //                             backgroundColor: 'rgba(0, 0, 0, 0.84)',
    //                             display: 'flex',
    //                             justifyContent: 'center',
    //                             alignItems: 'center',
    //                             zIndex: 9999
    //                         }}
    //                     >
    //                         <div
    //                             onClick={(e) => e.stopPropagation()}
    //                             style={{
    //                                 backgroundColor: 'white',
    //                                 padding: '40px 40px',
    //                                 borderRadius: '20px',
    //                                 width: '50%',
    //                                 maxHeight: '90vh',
    //                                 overflow: "hidden",
    //                                 boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    //                                 position: 'relative'
    //                             }}
    //                         >

    //                             <div className="col-12">

    //                                 <div className="col-12  mb-3">
    //                                     <div className="row">
    //                                         <div className="col-6">
    //                                             <h5 className='fw-bold'>Bill Details</h5>
    //                                         </div>

    //                                         <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
    //                                             <button
    //                                                 onClick={() => setSelectedProposal(null)}
    //                                                 style={{
    //                                                     width: '32px',
    //                                                     height: '32px',
    //                                                     borderRadius: '50%',
    //                                                     backgroundColor: 'red',
    //                                                     border: 'none',
    //                                                     display: 'flex',
    //                                                     justifyContent: 'center',
    //                                                     alignItems: "center",
    //                                                     cursor: 'pointer',
    //                                                     fontSize: '24px',
    //                                                     fontWeight: 'bold',
    //                                                     color: 'white',
    //                                                     lineHeight: 1
    //                                                 }}
    //                                             >
    //                                                 ×
    //                                             </button>
    //                                         </div>
    //                                     </div>
    //                                 </div>

    //                                 <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
    //                                     <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
    //                                         <tbody>
    //                                             {Object.entries(selectedProposal).map(([key, value], index) => (
    //                                                 <>
    //                                                     <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
    //                                                         <td style={{
    //                                                             fontWeight: 'bold',
    //                                                             padding: '8px',
    //                                                             width: '40%',
    //                                                             backgroundColor: '#2B75D5',
    //                                                             color: 'white',
    //                                                             border: '1px solid #cce0f9'
    //                                                         }}>
    //                                                             {key}
    //                                                         </td>
    //                                                         <td style={{
    //                                                             padding: '8px',
    //                                                             color: "black",
    //                                                             backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

    //                                                         }}>
    //                                                             {/* Handle Upload Bill Copy link */}
    //                                                             {key === 'Upload Bill Copy' && value ? (
    //                                                                 <a href={`${apiurl}/BillCopyDocsImages/${value}`} target="_blank" rel="noreferrer">
    //                                                                     {value}
    //                                                                 </a>
    //                                                             ) : value === null || value === '' ? (
    //                                                                 '-'
    //                                                             ) : (
    //                                                                 value.toString()
    //                                                             )}
    //                                                         </td>

    //                                                     </tr>

    //                                                 </>
    //                                             ))}
    //                                         </tbody>
    //                                     </table>
    //                                 </div>

    //                             </div>

    //                         </div>
    //                     </div>
    //                 )}
    //         </div>



    //     </>

    // )


    return (

        <>

            <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" ,position: "relative" }}>
               {/* 🔥 Blur Wrapper */}
    <div
      style={{
        filter: loading ? "blur(4px)" : "none",
        pointerEvents: loading ? "none" : "auto",
        transition: "0.2s ease",
      }}
    > 
                <div className="col-11 m-auto">
                <div
          className="col-12 px-4 mb-4 mt-3"
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
                      {/* ================= HEADER ROW ================= */}
<div
 className="d-flex justify-content-between align-items-center mb-2 flex-wrap"
>
  <h5 className="fw-bold d-flex align-items-center m-0">
    <img
      src="/GR-Approval64.png"
      alt="icon"
      style={{ width: "24px", height: "24px" }}
      className="me-2"
    />
    {[24, 25, 29, 40, 41].includes(RoleID)
  ? t("Demand Request Status")
  : t("Demand Request Outward")}
  </h5>
<div className="d-flex gap-2"> 
      <button
                                className="btn btn-success"
                                onClick={() =>
                                    exportTableByClassToExcel(sortedBills, "Demand_Request_Outward.xlsx.xlsx")
                                }
                                >
                                {t("Download Excel")}
                                </button>
                                   <button
      className="btn btn-danger"
      onClick={() =>
        downloadTableOnlyAsPDF(
          "DemandRequestoutward",
          "DemandRequestoutward.pdf",
          "Demand Request outward"
        )
      }
    >
      {t("Download PDF")}
    </button>
</div>
</div>

{/* ================= FILTER ROW ================= */}
<div
  className="col-12 px-4 mb-4 mt-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap"
  }}
>
  {UserRole === "State" && RoleID == 29 && (
                  <select
                    value={typeofData}
                    onChange={(e) => settypeofData(e.target.value)}
                    style={{
                      width: "150px",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                       fontSize:"13px"  , whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                    }}
                  >
                    <option value="" disabled selected>
                      Choose Data
                    </option>
                    <option value="District" >{t("3054-2419(Roads and bridge repair maintenance program)")}</option>
                    <option value="State">{t("2515-1238(MLA Representative)")}</option>
                  </select>
                )}
  {/* Status Filter */}
  <div style={{ width: "150px" }}>
    <select
      value={statusofData}
      onChange={(e) => setstatusofData(e.target.value)}
      style={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
         fontSize: "13px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      <option value="">{t("All")}</option>
         <option value="Approved">{t("Approved")}</option>
      <option value="Pending">{t("Pending")}</option>
      <option value="Rejected">{t("Rejected")}</option>
    </select>
  </div>

   {/* District Filter */}
{UserRole === "State" && (
  <div style={{ position: "relative", width: "170px" }}>
    
    {/* Trigger */}
    <div
      onClick={() => setOpenDistrict(prev => !prev)}
      style={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        cursor: "pointer",
        fontSize: "13px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      {SelectedDistrict.length > 0
        ? SelectedDistrict.join(", ")
        : t("Select District")}
    </div>

    {/* Dropdown */}
    {openDistrict && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          width: "100%",
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          zIndex: 10
        }}
        onClick={(e) => e.stopPropagation()} // ✅ prevents close on click
      >
          <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 8px",
            borderBottom: "1px solid #eee",
            cursor: "pointer",
            fontSize:"13px"  , whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
          }}
        >
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleAllDistricts}
            style={{ marginRight: "6px" }}
          />
          {t("All Districts")}
        </label>
        {/* Options */}
        <div style={{ maxHeight: "150px", overflowY: "auto" }}>
          {[...new Set(AllDistrict?.map(d => d.District_Marathi))].map(
            (district, index) => (
              <label
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 8px",
                  cursor: "pointer",
                  fontSize:"13px"  , whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                }}
              >
                <input
                  type="checkbox"
                  checked={SelectedDistrict.includes(district)}
                  onChange={() => handleDistrictToggle(district)}
                  style={{ marginRight: "6px" }}
                />
                {district}
              </label>
            )
          )}
        </div>

        {/* OK Button */}
        <div
          style={{
            borderTop: "1px solid #eee",
            padding: "6px",
            textAlign: "right"
          }}
        >
          <button
            onClick={() => setOpenDistrict(false)}
            style={{
              padding: "4px 10px",
              fontSize: "12px",
              borderRadius: "6px",
              border: "none",
              background: "#0d6efd",
              color: "#fff",
              cursor: "pointer"
            }}
          >
            OK
          </button>
        </div>
      </div>
    )}
  </div>
)}


  {/* Search */}
  <div style={{ position: "relative", width: "250px" }}>
    <img
      src="/Search32.png"
      alt="search"
      style={{
        position: "absolute",
        top: "50%",
        left: "10px",
        transform: "translateY(-50%)",
        width: "16px",
        height: "16px",
        opacity: 0.6
      }}
    />
    <input
      type="text"
      placeholder={t("Search")}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        width: "100%",
        padding: "8px 12px 8px 32px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize:"13px"  , whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
      }}
    />
  </div>
</div>


                        <div className='col-12 pb-5'>
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                    <table className='m-0 p-0 DemandRequestoutward' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                <th style={{ padding: "7px 10px", minWidth: "60px" }} rowSpan={2} colSpan={1}>{t("Sr.No.")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "100px" }} rowSpan={2} colSpan={1}>{t("Financial Year")}</th>
                                                {UserRole=="State"  && RoleID!=29 ? "":<th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th>}
                                                <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
                                                     <th
                                  style={{ padding: "7px 10px", minWidth: "150px" }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Job ID")}
                                </th>
                                                <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("MHUID Number")}</th>
                                                <th
                                  style={{ padding: "7px 10px", minWidth: "150px" }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Demand Copy")}
                                </th>
                                                <th style={{ padding: "7px 10px", minWidth: "100px" }} rowSpan={2} colSpan={1}>{t("Physical Progress (%)")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "100px" }} rowSpan={2} colSpan={1}>{t("District")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "140px" }} rowSpan={2} colSpan={1}>{t("Expenditure Amount")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2} colSpan={1}>{t("Approved Demand Request Amount")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2} colSpan={1}>{t("Work Order Amount")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2} colSpan={1}>{t("Available Amount for Demand Request")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2}>{t("Rejected?")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2}>{t("Remark")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "160px" }} rowSpan={2}>{t("Rejected By")}</th>
                                                <th style={{ padding: "7px 10px" }} colSpan={2}>{t("Approved by")}</th>
                                            </tr>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', width: "100%" }}>
                                                <th style={{ padding: "7px 10px", minWidth: "190px" }}>{t("District Department Maker")}</th>
                                                <th style={{ padding: "7px 10px", minWidth: "170px" }}>{t("Department HOD(EE)")}</th>
                                            </tr>
                                        </thead>

                                        <tbody >
                                            <> 
                                            {displayedGRS1?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                displayedGRS1?.map((proposal, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr style={{ backgroundColor: bgColor }} key={index}>
                                                            <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
                                                            {UserRole=="State"  && RoleID!=29 ? "":<td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>}
                                                            <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
                                                            <td style={{ padding: "8px 8px" }}>
                                          {proposal.JOB_ID}
                                        </td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
                                                             <td style={{ padding: "8px" }}>
                                                                                                    {proposal.DemandCopy ? (
                                                                                                      <a
                                                                                                        href={`${apiurl}/DemandRequestDocs/${proposal.DemandCopy}`}
                                                                                                        target="_blank"
                                                                                                        rel="noreferrer"
                                                                                                      >
                                                                                                        {proposal.DemandCopy}
                                                                                                      </a>
                                                                                                    ) : (
                                                                                                      <p className="text-danger my-auto fw-bold">
                                                                                                        {t("No File")}
                                                                                                      </p>
                                                                                                    )}
                                                                                                  </td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
                                                            <td style={{ padding: '8px 8px' }}>{getAvailableApprovedDemandRequest(
                                                                proposal.physicalValue,
                                                                proposal.AvailableWorkOrderAmount,
                                                                proposal.ApprovedDemandRequest,
                                                            )}</td>
                                                            {/* <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td> */}
                                                            <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString()}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.Status === 'NA' ? 'No' : 'Yes'}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.RemarkOfRejection || "--"}</td>
                                                            <td style={{ padding: '8px 8px' }}>{proposal.RejectedBy === null ? 'None' : proposal.RejectedBy}</td>
                                                            <td style={{ padding: '8px 8px' }}>
                                                                {proposal.Approvance1 === 'true' ? (
                                                                    <div className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#16C60C',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✓
                                                                    </div>
                                                                ) : proposal.Approvance1 === 'false' ? (
                                                                    <div
                                                                        className='m-auto'
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: '#dc2626',
                                                                            border: 'none',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            fontSize: '13px',
                                                                            color: 'white',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        ✕
                                                                    </div>
                                                                ) : '-'}
                                                            </td>
                                                            <td style={{ padding: '8px 8px' }}>
                                                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#16C60C',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✓
                                                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                                                    className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#dc2626',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </div>) : '-'}
                                                            </td>
                                                        </tr>

                                                    );
                                                })
                                            )}

                                             <tr
        style={{
          fontWeight: "600",
          backgroundColor: "#f0f0f0",
          fontSize: "13px",
        }}
      >
        <td colSpan={UserRole=="State" && RoleID!=29 ?7:8} style={{ textAlign: "left", padding: "8px" }}>
          {t("Total")}
        </td>

        <td style={{ padding: "8px" }}  >
          ₹ {totalExpendeture.toLocaleString("en-IN")}
        </td>
  <td style={{ padding: "8px" }}  >
          ₹ {totalapproved.toLocaleString("en-IN")}
        </td>
        <td style={{ padding: "8px" }}  >
          ₹ {totalworkorder.toLocaleString("en-IN")}
        </td>
        <td style={{ padding: "8px" }}  >
          ₹ {totalavailable.toLocaleString("en-IN")}
        </td>
      
        {/* remaining columns */}
        <td colSpan={UserRole=="State"?18:19}></td>
      </tr>
                                                     </>
                                        </tbody>
                                    </table>
                                </div>
                                <div className='col-12 mt-4 mb-2' >
                                    <div className="row">
                                        <div className='col-6'>
                                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                                {proposallist.length > 0
                                                    ? t(`Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`)
                                                    : t("Showing 0 to 0 of 0 entries")
                                                }
                                            </p>
                                        </div>
                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
                                            <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                                                {currentPage}
                                            </button>
                                            <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
                                            <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>



                    </div>



                </div>

                {
                    selectedProposal && (
                        <div
                            onClick={() => setSelectedProposal(null)}
                            style={{
                                position: 'fixed',
                                top: 0, left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.84)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999
                            }}
                        >
                            <div
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                    backgroundColor: 'white',
                                    padding: '40px 40px',
                                    borderRadius: '20px',
                                    width: '50%',
                                    maxHeight: '90vh',
                                    overflow: "hidden",
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                    position: 'relative'
                                }}
                            >

                                <div className="col-12">

                                    <div className="col-12  mb-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <h5 className='fw-bold'>{t("Bill Details")}</h5>
                                            </div>

                                            <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <button
                                                    onClick={() => setSelectedProposal(null)}
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: 'red',
                                                        border: 'none',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: "center",
                                                        cursor: 'pointer',
                                                        fontSize: '24px',
                                                        fontWeight: 'bold',
                                                        color: 'white',
                                                        lineHeight: 1
                                                    }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
                                        <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
                                            <tbody>
                                                {Object.entries(selectedProposal).map(([key, value], index) => (
                                                    <>
                                                        <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
                                                            <td style={{
                                                                fontWeight: 'bold',
                                                                padding: '8px',
                                                                width: '40%',
                                                                backgroundColor: '#2B75D5',
                                                                color: 'white',
                                                                border: '1px solid #cce0f9'
                                                            }}>
                                                                {key}
                                                            </td>
                                                            <td style={{
                                                                padding: '8px',
                                                                color: "black",
                                                                backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

                                                            }}>
                                                                {/* Handle Upload Bill Copy link */}
                                                                {key === 'Upload Bill Copy' && value ? (
                                                                    <a href={`${apiurl}/BillCopyDocsImages/${value}`} target="_blank" rel="noreferrer">
                                                                        {value}
                                                                    </a>
                                                                ) : value === null || value === '' ? (
                                                                    '-'
                                                                ) : (
                                                                    value.toString()
                                                                )}
                                                            </td>

                                                        </tr>

                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            </div>
                        </div>
                    )}
            </div>


 {/* 🔥 Loader Overlay */}
    {loading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.4)",
          backdropFilter: "blur(2px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <div className="Adminloader"></div>
      </div>
    )}
  </div>
        </>

    )
}

export default DemandRequestOutwards;
